import { MARQUEE } from "../data/content";

export const Marquee = () => {
  const row = [...MARQUEE, ...MARQUEE];
  return (
    <div className="overflow-hidden border-y border-[#E5DFD5] bg-[#F3EFEA] py-6" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={i} className="flex items-center font-display text-3xl italic text-[#3A3632] sm:text-4xl">
                <span className="px-8">{t}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#A88350]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
